// Set at page load in public/index.html
export const basePath = window.BASE_PATH || "";
